"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Panel = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Panel = exports.Panel = /*#__PURE__*/function () {
  function Panel(name, foreground, background, msRefresh, refreshCallback) {
    _classCallCheck(this, Panel);
    this.name = name;
    this.foreground = foreground;
    this.background = background;
    this.msRefresh = msRefresh;
    this.refreshCallback = refreshCallback;
    _defineProperty(this, "dom", void 0);
    _defineProperty(this, "data", void 0);
    _defineProperty(this, "_max", void 0);
    _defineProperty(this, "_min", void 0);
    _defineProperty(this, "lastTime", void 0);
    _defineProperty(this, "canvas", void 0);
    _defineProperty(this, "context", void 0);
    _defineProperty(this, "pixelRatio", void 0);
    _defineProperty(this, "width", void 0);
    _defineProperty(this, "height", void 0);
    _defineProperty(this, "text", void 0);
    _defineProperty(this, "graph", void 0);
    this.data = [];
    this._min = Infinity;
    this._max = 0;
    this.lastTime = 0;
    this.pixelRatio = Math.round(devicePixelRatio || 1);
    this.width = 100 * this.pixelRatio;
    this.height = 60 * this.pixelRatio;
    this.text = {
      position: {
        x: 3 * this.pixelRatio,
        y: 2 * this.pixelRatio
      }
    };
    this.graph = {
      position: {
        x: 3 * this.pixelRatio,
        y: 18 * this.pixelRatio
      },
      size: {
        width: 94 * this.pixelRatio,
        height: 40 * this.pixelRatio
      }
    };
    this.canvas = document.createElement("canvas");
    this.canvas.width = this.width;
    this.canvas.height = this.height;
    this.canvas.style.width = "100px";
    this.canvas.style.height = "60px";
    this.canvas.style.borderRadius = "5px";
    this.context = this.canvas.getContext("2d");
    this.init();
    this.dom = this.canvas;
  }
  return _createClass(Panel, [{
    key: "min",
    get: function get() {
      return this._min;
    }
  }, {
    key: "max",
    get: function get() {
      return this._max;
    }
  }, {
    key: "init",
    value: function init() {
      if (!this.context) {
        return;
      }
      var fontSize = 12 * this.pixelRatio;

      // draws title
      this.context.font = "400 ".concat(fontSize, "px \"Avenir Next\", Helvetica, \"Helvetica Neue\", Arial, sans-serif");
      this.context.textBaseline = "top";
      this.context.fillStyle = this.background;
      this.context.fillRect(0, 0, this.width, this.height);
      this.context.fillStyle = this.foreground;
      this.context.fillText(this.name, this.text.position.x, this.text.position.y);
    }
  }, {
    key: "update",
    value: function update(time) {
      var _this = this;
      var delta = time - this.lastTime;
      if (delta < this.msRefresh) {
        return;
      }
      var args = this.refreshCallback(time, delta);
      if (!args) {
        return;
      }
      this.lastTime = time;
      var value = args.value,
        maxValue = args.maxValue;
      this._min = Math.min(this._min, value);
      this._max = Math.max(this._max, value);
      this.data.push(value);
      var realMax = Math.max(this._max, maxValue);
      if (this.data.length > this.graph.size.width) {
        this.data.splice(0, this.data.length - this.graph.size.width);
      }
      if (!this.context) {
        return;
      }

      // draws background
      this.context.fillStyle = this.background;
      this.context.globalAlpha = 1;
      this.context.fillRect(0, 0, this.width, this.height);

      // draws title
      this.context.fillStyle = this.foreground;
      this.context.fillText("".concat(Math.round(value), " ").concat(this.name, " (").concat(Math.round(this._min), "-").concat(Math.round(this._max), ")"), this.text.position.x, this.text.position.y);

      // draws the graph line
      this.context.beginPath();
      this.context.moveTo(this.data.length + this.graph.position.x, (1 - this.data[this.data.length - 1] / realMax) * this.graph.size.height + this.graph.position.y);
      for (var i = this.data.length - 1; i > 0; i--) {
        var cpx = i - 1 / 2 + this.graph.position.x;
        var cpy = function cpy(v) {
          return (1 - v / realMax) * _this.graph.size.height + _this.graph.position.y;
        };
        var cp1y = cpy(this.data[i]);
        var cp2y = cpy(this.data[i - 1]);
        this.context.bezierCurveTo(cpx, cp1y, cpx, cp2y, i - 1 + this.graph.position.x, cp2y);
      }
      this.context.strokeStyle = this.foreground;
      this.context.stroke();
    }
  }]);
}();
//# sourceMappingURL=Panel.js.map